import { render, staticRenderFns } from "./FlowCertificate.vue?vue&type=template&id=1a0354fb&"
import script from "./FlowCertificate.vue?vue&type=script&lang=js&"
export * from "./FlowCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports